import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54310088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "default-layout" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-push" }, null, -1))

import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ]),
      _hoisted_4
    ]),
    _createVNode(Footer)
  ]))
}
}

})